import { z } from 'zod';
export var generateZodSchema = function (fields) {
    var schema = {};
    fields.forEach(function (field) {
        var _a, _b, _c, _d, _e;
        switch (field.type) {
            case 'text':
            case 'email':
            case 'password':
            case 'tel':
            case 'url':
                schema[field.name] = (field === null || field === void 0 ? void 0 : field.required)
                    ? z
                        .string()
                        .min(1, (field === null || field === void 0 ? void 0 : field.label) ? "".concat(field.label, " is required") : 'Input is Required')
                        .max(field.maxLength || Infinity, (field === null || field === void 0 ? void 0 : field.label) ? "".concat(field.label, " is too long") : 'Input is too long')
                    : z
                        .string()
                        .max(field.maxLength || Infinity, (field === null || field === void 0 ? void 0 : field.label) ? "".concat(field.label, " is too long") : 'Input is too long');
                if ((_a = field.validation) === null || _a === void 0 ? void 0 : _a.pattern) {
                    schema[field.name] = (field === null || field === void 0 ? void 0 : field.required)
                        ? z
                            .string()
                            .min(1, (field === null || field === void 0 ? void 0 : field.label) ? "".concat(field.label, " is required") : 'Input is Required')
                            .max(field.maxLength || Infinity, (field === null || field === void 0 ? void 0 : field.label) ? "".concat(field.label, " is too long") : 'Input is too long')
                            .regex(new RegExp(field.validation.pattern), (field === null || field === void 0 ? void 0 : field.label) ? "".concat(field.label, " is invalid") : 'Invalid Input')
                        : z
                            .string()
                            .max(field.maxLength || Infinity, (field === null || field === void 0 ? void 0 : field.label) ? "".concat(field.label, " is too long") : 'Input is too long')
                            .regex(new RegExp(field.validation.pattern), (field === null || field === void 0 ? void 0 : field.label) ? "".concat(field.label, " is invalid") : 'Invalid Input')
                            .optional()
                            .or(z.literal(''));
                }
                break;
            case 'number':
                schema[field.name] = z
                    .number()
                    .min(((_b = field.validation) === null || _b === void 0 ? void 0 : _b.min) || 0, "Minimum value is ".concat((_c = field.validation) === null || _c === void 0 ? void 0 : _c.min))
                    .max(((_d = field.validation) === null || _d === void 0 ? void 0 : _d.max) || Infinity, "Maximum value is ".concat((_e = field.validation) === null || _e === void 0 ? void 0 : _e.max));
                break;
            case 'date':
                schema[field.name] = z.string().refine(function (value) {
                    var _a, _b;
                    var date = new Date(value);
                    if (((_a = field.validation) === null || _a === void 0 ? void 0 : _a.maxDate) && new Date(field.validation.maxDate) < date) {
                        return false;
                    }
                    if ((_b = field.validation) === null || _b === void 0 ? void 0 : _b.minAge) {
                        var age = new Date().getFullYear() - date.getFullYear();
                        return age >= field.validation.minAge;
                    }
                    return true;
                }, (field === null || field === void 0 ? void 0 : field.label) ? "".concat(field.label, " is invalid") : 'Invalid Input');
                break;
            case 'boolean':
                schema[field.name] = z.boolean();
                break;
            case 'select':
                schema[field.name] = field.required
                    ? z
                        .object({
                        label: z.string(),
                        value: z.string(),
                    })
                        .required()
                    : z
                        .object({
                        label: z.string(),
                        value: z.string(),
                    })
                        .nullable();
                break;
            case 'multiselect':
                schema[field.name] = field.required
                    ? z
                        .array(z.object({
                        label: z.string(),
                        value: z.string(),
                    }))
                        .min(1, field.label ? "".concat(field.label, " is required") : 'Input is Required')
                    : z
                        .array(z.object({
                        label: z.string(),
                        value: z.string(),
                    }))
                        .nullable();
                break;
            case 'array':
                schema[field.name] = z
                    .array(generateZodSchema([field.itemTemplate]))
                    .min(field.minItems || 0)
                    .max(field.maxItems || Infinity);
                break;
            case 'section':
            case 'location':
            case 'object':
                schema[field.name] = generateZodSchema(field.fields || []);
                break;
            default:
                schema[field.name] = z.any();
        }
    });
    return z.object(schema);
};
